<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@/modules/report/document'
import providerApi from '@/services/api/provider.api'
import AcademicYearServices from '@/services/api/academicyear.api'
import specialistApi from '@/services/api/specialist.api'
import codeApi from '@/services/api/code.api'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Cumplimiento semanal de registro de visitas',
      routes: ['Informes', 'Cumplimiento semanal de registro de visitas'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          specialists: [],
          providers: [],
          specialties: [],
        },
        filters: {
          academicYear: null,
          specialist: null,
          provider: null,
          specialty: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          class: 'col-md-4',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },

        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          class: 'col-md-4',
          disabled:
            this.model.search.collections.providers.length <= 0 ||
            this.model.search.collections.providers.length == 1,
          onChanged: this.onChangeProvider,
        },
        {
          name: 'specialist',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Especialista',
          placeholder: 'Seleccionar',
          validations: this.model.search.filters.sie === null ? 'required' : '',
          error: 'Favor de seleccionar un Especialista.',
          options: this.model.search.collections.specialists,
          value: this.model.search.filters.specialist,
          class: 'col-md-4',
          disabled: this.model.search.collections.specialists.length <= 1,
        },
        {
          name: 'serviceType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Servicio',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un tipo de servicio.',
          validations: 'required',
          clearable: false,
          class: 'col-md-4',
          options: this.model.search.collections.serviceTypes,
          value: this.model.search.filters.serviceType,
        },
        {
          name: 'sie',
          component: 'CustomInput',
          type: 'text',
          label: 'SIE',
          placeholder: 'Escriba número de SIE',
          icon: 'fa fa-search orange-icon',
          validations:
            this.model.search.filters.specialist === null ? 'required' : '',
          error: 'Favor de ingresar SIE.',
          class: 'col-md-4',
          leftIcon: true,
          value: this.model.search.filters.sie,
          disabled: this.model.search.filters.sieDisabled,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears().then(
        (res) => (this.model.search.collections.academicYears = res.data)
      )
      await codeApi
        .getDisciplineTypeServices()
        .then((res) => (this.model.search.collections.serviceTypes = res.data))
    },
    async onChangeAcademicYear() {
      this.model.search.filters.specialist = null
      this.model.search.filters.provider = null
      this.model.search.collections.specialists = []
      this.model.search.collections.providers = []
      await this.getProvider()
    },
    async onChangeProvider() {
      this.model.search.collections.specialists = []
      this.model.search.filters.specialist = null
      await this.getSpecialist()
    },
    async getProvider() {
      await providerApi
        .getCompaniesByEffectiveContract({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.providers = res.data

          if (res.data.length == 1) {
            this.model.search.filters.provider = res.data[0];
            this.onChangeProvider();
          }
        })
    },
    async getSpecialist() {
      await specialistApi
        .getSpecialistProvider({
          academicYearId: this.model.search.filters.academicYear?.id,
          companyId: this.model.search.filters.provider?.id,
        })
        .then((res) => {
          this.model.search.collections.specialists = res.data

          if (res.data.length == 1) {
            this.model.search.filters.specialist = res.data[0];
          }
        })
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (isValid) {
        this.process()
      }
    },
    async process() {
      await ReportServices.getReport('getweeklycompliance', {
        academicYearId: this.model.search.filters.academicYear.id,
        serviceId: this.model.search.filters.serviceType.id,
        studentSieId: this.model.search.filters?.sie ?? '',
        specialistId: this.model.search.filters?.specialist?.id ?? null,
        providerId: this.model.search.filters?.provider?.id ?? null
      }).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>
